/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as SettingsRouteImport } from './routes/settings';
import { Route as IndexRouteImport } from './routes/index';
import { Route as TripsIndexRouteImport } from './routes/trips/index';
import { Route as LibraryIndexRouteImport } from './routes/library/index';
import { Route as AdminIndexRouteImport } from './routes/admin/index';
import { Route as ActivitiesIndexRouteImport } from './routes/activities/index';
import { Route as TripsTripIdRouteImport } from './routes/trips/$tripId';
import { Route as LibraryListIdRouteImport } from './routes/library/$listId';

const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any);
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any);
const TripsIndexRoute = TripsIndexRouteImport.update({
  id: '/trips/',
  path: '/trips/',
  getParentRoute: () => rootRouteImport,
} as any);
const LibraryIndexRoute = LibraryIndexRouteImport.update({
  id: '/library/',
  path: '/library/',
  getParentRoute: () => rootRouteImport,
} as any);
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => rootRouteImport,
} as any);
const ActivitiesIndexRoute = ActivitiesIndexRouteImport.update({
  id: '/activities/',
  path: '/activities/',
  getParentRoute: () => rootRouteImport,
} as any);
const TripsTripIdRoute = TripsTripIdRouteImport.update({
  id: '/trips/$tripId',
  path: '/trips/$tripId',
  getParentRoute: () => rootRouteImport,
} as any);
const LibraryListIdRoute = LibraryListIdRouteImport.update({
  id: '/library/$listId',
  path: '/library/$listId',
  getParentRoute: () => rootRouteImport,
} as any);

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/settings': typeof SettingsRoute;
  '/library/$listId': typeof LibraryListIdRoute;
  '/trips/$tripId': typeof TripsTripIdRoute;
  '/activities/': typeof ActivitiesIndexRoute;
  '/admin/': typeof AdminIndexRoute;
  '/library/': typeof LibraryIndexRoute;
  '/trips/': typeof TripsIndexRoute;
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/settings': typeof SettingsRoute;
  '/library/$listId': typeof LibraryListIdRoute;
  '/trips/$tripId': typeof TripsTripIdRoute;
  '/activities': typeof ActivitiesIndexRoute;
  '/admin': typeof AdminIndexRoute;
  '/library': typeof LibraryIndexRoute;
  '/trips': typeof TripsIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/': typeof IndexRoute;
  '/settings': typeof SettingsRoute;
  '/library/$listId': typeof LibraryListIdRoute;
  '/trips/$tripId': typeof TripsTripIdRoute;
  '/activities/': typeof ActivitiesIndexRoute;
  '/admin/': typeof AdminIndexRoute;
  '/library/': typeof LibraryIndexRoute;
  '/trips/': typeof TripsIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/settings'
    | '/library/$listId'
    | '/trips/$tripId'
    | '/activities/'
    | '/admin/'
    | '/library/'
    | '/trips/';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/settings'
    | '/library/$listId'
    | '/trips/$tripId'
    | '/activities'
    | '/admin'
    | '/library'
    | '/trips';
  id:
    | '__root__'
    | '/'
    | '/settings'
    | '/library/$listId'
    | '/trips/$tripId'
    | '/activities/'
    | '/admin/'
    | '/library/'
    | '/trips/';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  SettingsRoute: typeof SettingsRoute;
  LibraryListIdRoute: typeof LibraryListIdRoute;
  TripsTripIdRoute: typeof TripsTripIdRoute;
  ActivitiesIndexRoute: typeof ActivitiesIndexRoute;
  AdminIndexRoute: typeof AdminIndexRoute;
  LibraryIndexRoute: typeof LibraryIndexRoute;
  TripsIndexRoute: typeof TripsIndexRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/settings': {
      id: '/settings';
      path: '/settings';
      fullPath: '/settings';
      preLoaderRoute: typeof SettingsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/trips/': {
      id: '/trips/';
      path: '/trips';
      fullPath: '/trips/';
      preLoaderRoute: typeof TripsIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/library/': {
      id: '/library/';
      path: '/library';
      fullPath: '/library/';
      preLoaderRoute: typeof LibraryIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/admin/': {
      id: '/admin/';
      path: '/admin';
      fullPath: '/admin/';
      preLoaderRoute: typeof AdminIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/activities/': {
      id: '/activities/';
      path: '/activities';
      fullPath: '/activities/';
      preLoaderRoute: typeof ActivitiesIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/trips/$tripId': {
      id: '/trips/$tripId';
      path: '/trips/$tripId';
      fullPath: '/trips/$tripId';
      preLoaderRoute: typeof TripsTripIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/library/$listId': {
      id: '/library/$listId';
      path: '/library/$listId';
      fullPath: '/library/$listId';
      preLoaderRoute: typeof LibraryListIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SettingsRoute: SettingsRoute,
  LibraryListIdRoute: LibraryListIdRoute,
  TripsTripIdRoute: TripsTripIdRoute,
  ActivitiesIndexRoute: ActivitiesIndexRoute,
  AdminIndexRoute: AdminIndexRoute,
  LibraryIndexRoute: LibraryIndexRoute,
  TripsIndexRoute: TripsIndexRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
